module.exports = __webpack_public_path__ + "img/b3.8ee96df2.png";